import { createSlice } from "@reduxjs/toolkit";

/**
 * @name @createSlice
 * @description create redux store slice for auth
 **/
export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    createData: null,
    draftGraphFilter: {},
    draftFields: {},
    detailView: null,
  },

  reducers: {
    /**
     * @name @login
     * @description login reducer to call login async API with axios instance
     * @requires ApiServices.get method, state and API payload
     **/
    setCreateData: (state, action) => {
      state.createData = action.payload;
    },
    setDraftGraphFilter: (state, action) => {
      const { key, filters } = action.payload;
      state.draftGraphFilter[key] = filters;
    },
    clearDraftGraphFilter: (state, action) => {
      const { key } = action.payload;
      delete state.draftGraphFilter[key];
    },
    setDashboardDraftField: (state, action) => {
      const { draftKey, data } = action.payload || {};
      if (!draftKey) return;
      state.draftFields[draftKey] = {
        ...(state.draftFields[draftKey] || {}),
        ...data,
      };
    },
    clearDashboardDraftField: (state, action) => {
      const { draftKey } = action.payload || {};
      if (!draftKey) return;
      delete state.draftFields[draftKey];
    },
    setDashboardDetailView: (state, action) => {
      state.detailView = action.payload || null;
    },
    clearDashboardDetailView: (state) => {
      state.detailView = null;
    },
    resetDashboardNavSubpageState: (state) => {
      state.createData = null;
      state.draftGraphFilter = {};
      state.draftFields = {};
      state.detailView = null;
    },
  },
});

export const {
  setCreateData,
  setDraftGraphFilter,
  clearDraftGraphFilter,
  setDashboardDraftField,
  clearDashboardDraftField,
  setDashboardDetailView,
  clearDashboardDetailView,
  resetDashboardNavSubpageState,
} = dashboardSlice.actions;

/**
 * These function called thunk and allows to perform async logic
 * It can be dispatched like a regular action: `dispatch(data)`
 **/

/* called a selector and allows to select values from the state */
export const selectDashboardCreateData = (state) => {
  return state.dashboard.createData;
};

export const selectDraftGraphFilterByKey = (state, key) => {
  return state?.dashboard?.draftGraphFilter[key];
};

export const selectDashboardDraftField = (draftKey) => (state) => {
  return draftKey ? state?.dashboard?.draftFields?.[draftKey] : null;
};

export const selectDashboardDetailView = (state) => {
  return state?.dashboard?.detailView;
};

export default dashboardSlice.reducer;
